import { Sector } from '@/domain/impact/impact.entity';
import {
  CargoType,
  CargoValues,
  Category,
  ImpactCo2Answer,
  ValuesCargo,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'CARGO';
const SECTORS: Sector[] = ['ARTISTS', 'SITE'];

export function mapToCargoAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesCargo>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const transportationMode = mapToTransportationMode(row);
  const weight = mapToWeight(row);
  const travelDistance = mapToTravelDistance(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      transportationMode,
      weight,
      travelDistance,
    },
  };
  return answer;
}

function mapToTransportationMode(row: ImportedRow): CargoType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<CargoType>(tgsValue, CargoValues);
  if (!result) {
    throw new ImportMappingError('transportationMode', tgsValue, row);
  }
  return result;
}

function mapToWeight(row: ImportedRow): number {
  const tgsValue = row['Weight (kg)'];
  let result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('weight', tgsValue, row);
  }
  result = result / 1000; // convert kg to tonnes
  return result;
}

function mapToTravelDistance(row: ImportedRow): number {
  const tgsValue = row['Distance (Km)'];
  const result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('travelDistance', tgsValue, row);
  }
  return result;
}
